import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import Toggle from 'components/ReusableComponents/Toggle'
import { dripMediumNames } from 'features/CustomCampaigns/EditCampaign/CampaignSetup'

import styles from './EditDripStepDialog.module.scss'

const mediumDescriptions = {
  Text: 'Sends messages only by text (SMS) to guests with a valid mobile number.',
  Email: 'Sends messages only by email to guests with a valid email address.',
  TextWithEmailFallback:
    'Sends a text first; if the text cannot be sent, an email version is sent instead.',
  EmailAndText:
    'Sends both a text and an email at the same time—each with its own content.'
}

function ConfigurationStep({
  isEnabled,
  setIsEnabled,
  sendAfterValue,
  setSendAfterValue,
  sendAfterUnit,
  setSendAfterUnit,
  medium
}) {
  const defaultMax = sendAfterUnit === 'hours' ? 24 : 7
  const maxValue = Math.max(defaultMax, sendAfterValue || 0)
  const valueOptions = Array.from({ length: maxValue }, (_, i) => i + 1).reduce(
    (acc, n) => ({ ...acc, [n]: String(n) }),
    {}
  )

  const unitOptions = {
    hours: 'hours',
    days: 'days'
  }

  const handleUnitChange = e => {
    const newUnit = e.target.value
    setSendAfterUnit(newUnit)
    const newMax = newUnit === 'hours' ? 24 : 7
    if (sendAfterValue > newMax) {
      setSendAfterValue(newMax)
    }
  }

  return (
    <div className={styles.configurationStep}>
      <label className={styles.enabledToggle}>
        <Toggle
          checked={isEnabled}
          handleChange={e => setIsEnabled(e.target.checked)}
          isGray={false}
        />
        <span className={styles.enabledLabel}>Enabled</span>
      </label>

      <p className={styles.description}>
        This follow-up message is sent automatically after the configured delay from the
        previous step in the sequence.
      </p>

      <div className={styles.sendAfterSection}>
        <span className={styles.sectionLabel}>Send after previous step</span>
        <div className={styles.sendAfterInputs}>
          <Dropdown
            className={styles.valueDropdown}
            options={valueOptions}
            value={String(sendAfterValue)}
            onChange={e => setSendAfterValue(Number(e.target.value))}
            isSortedAlphabetically={false}
          />
          <Dropdown
            className={styles.unitDropdown}
            options={unitOptions}
            value={sendAfterUnit}
            onChange={handleUnitChange}
            isSortedAlphabetically={false}
          />
        </div>
      </div>

      <div className={styles.channelSection}>
        <span className={styles.sectionLabel}>Message channel</span>
        <p className={styles.channelValue}>{dripMediumNames[medium]}</p>
        <p className={styles.channelDescription}>{mediumDescriptions[medium]}</p>
        <p className={styles.channelHint}>
          The channel strategy is set once for the whole sequence in the Preferences tab.
        </p>
      </div>
    </div>
  )
}

export default ConfigurationStep
